export { default as default } from '../modules/unicode.js'


//////////////////
// WEBPACK FOOTER
// ../country-flag-icons/unicode/index.js
// module id = 322
// module chunks = 0 1